import {createSelector} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {IActivityState} from '@app/core/store/state/activity.state';

const _selectActivity = (state: IAppState) => state.activity;

export const selectPagination = createSelector(
	_selectActivity,
	(state: IActivityState) => state.pagination,
);
export const selectActivities = createSelector(
	_selectActivity,
	(state: IActivityState) => state.activities,
);
export const selectActivity = createSelector(
	_selectActivity,
	(state: IActivityState) => state.activity,
);
export const selectIsLoadingActivities = createSelector(
	_selectActivity,
	(state: IActivityState) => state.isLoading,
);
export const selectIsLoadingActivity = createSelector(
	_selectActivity,
	(state: IActivityState) => state.isLoadingActivity,
);
export const selectIsLoadingRelationActivity = createSelector(
	_selectActivity,
	(state: IActivityState) => state.isLoadingRelationActivity,
);
